module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Krypton-cropped.de258b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Krypton-cropped.jpg
// module id = eYUY
// module chunks = 0